import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StorageService } from './storage.service';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { catchError, tap } from 'rxjs/operators';

import { UtentiService } from './utenti.service';
import notify from 'devextreme/ui/notify';
import { Utente } from 'src/app/models/utente';
import { Permessi } from 'src/app/models/permessi';
import moment from 'moment';
import { MsalService } from '@azure/msal-angular';
import { RUOLO_AMMINISTRATORE, RUOLO_OPERATORE_BASE } from 'src/app/consts/const';
import { ArticoliService } from './articoli.service';
import { CategorieArticoliService } from './categorie-articoli.service';
import { CausaliMovmagService } from './causali-movmag.service';
import { DipendentiService } from './dipendenti.service';
import { DistributoriService } from './distributori.service';
import { MansioniService } from './mansioni.service';
import { MovimentoArticoliService } from './movimento-articoli.service';
import { RepartiService } from './reparti.service';
import { SitiService } from './siti.service';
import { TipiArticoliService } from './tipi-articoli.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private router = inject(Router);
  private http = inject(HttpClient);
  private ss = inject(StorageService);
  private us = inject(UtentiService);
  private msalService = inject(MsalService);
  private articoliService = inject(ArticoliService);
  private categorieArticoliService = inject(CategorieArticoliService);
  private causaliMovService = inject(CausaliMovmagService);
  private dipendentiService = inject(DipendentiService);
  private distributoriService = inject(DistributoriService);
  private mansioniService = inject(MansioniService);
  private movimentiArticoliService = inject(MovimentoArticoliService);
  private repartiService = inject(RepartiService);
  private sitiService = inject(SitiService);
  private tipiArticoliService = inject (TipiArticoliService);


  loggedIn = false;
  private securityUrl = environment.ildatoArticoliDpi + 'api/auth/login';
  private refreshTokenUrl =
    environment.ildatoArticoliDpi + 'api/auth/refreshtoken';
  private securityUrlWithNewPassword =
    environment.ildatoArticoliDpi + 'api/auth/loginwithnewpassword';
  private securityByEntraIdUrl =
    environment.ildatoArticoliDpi + 'api/entraid/login';

  private utenteSubject = new BehaviorSubject<Utente>(undefined);
  private permessiSubject = new BehaviorSubject<Permessi>(undefined);
  private parametriSubject = new BehaviorSubject<any>(undefined);

  constructor() {
    this.init();
  }

  init() {
    console.log('init auth service');
    if (!this.loggedIn) {
      this.loadToken();
    }
  }

  logIn(username: string, password: string): Observable<any> {
    const mess =
      '{"username":"' +
      username +
      '", "password":"' +
      password +
      '", "grant_type":"password"}';

    //console.log(body.toString());
    return this.http
      .post<any>(`${this.securityUrl}`, mess, {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
      })
      .pipe(
        tap((token) => {
          //console.log('ricevuto token:' + token.access_token);
          this.ss.setCurrentToken(token.token);
          this.loggedIn = true;
          this.ss.setCurrentUtente(token.utente);
          //this.ss.setCurrentExpiration(token.expirationLocal);
          this.ss.setCurrentPermessi(token.permessi);
          this.ss.setCurrentParametriLogin(token.parametriLogin);

          if (token.expirationLocal) {
            this.ss.setCurrentTokenExpiration(moment(token.expirationLocal));
          }

          this.utenteSubject.next(token.utente);
          this.permessiSubject.next(token.permessi);
        }),
        catchError((err) => {
          notify('Errore di autenticazione', 'warning', 1000);
          console.error('auth error');
          return of(err);
        }),
      );
  }

  logInWithNewPassword(
    username: string,
    password: string,
    newPassword: string,
  ): Observable<any> {
    const mess =
      '{"username":"' +
      username +
      '", "password":"' +
      password +
      '", "newPassword":"' +
      newPassword +
      '", "grant_type":"password"}';

    //console.log(body.toString());
    return this.http
      .post<any>(`${this.securityUrlWithNewPassword}`, mess, {
        headers: new HttpHeaders().set('Content-Type', 'application/json'),
      })
      .pipe(
        tap((res) => {
          if (res.token && res.utente) {
            this.ss.setCurrentToken(res.token);
            // console.log('token:' +  JSON.stringify(token))
            this.ss.setCurrentUtente(res.utente);
            this.ss.setCurrentPermessi(res.permessi);
            this.ss.setCurrentParametri(res.parametri);
            //this.ss.setCurrentParametriLogin(res.parametriLogin);

            if (res.expirationLocal) {
              this.ss.setCurrentTokenExpiration(moment(res.expirationLocal));
            }

            // notifico ai sottoscrittori interessati che un nuovo utente ha fatto login
            this.utenteSubject.next(res.utente);
            this.permessiSubject.next(res.permessi);
            this.parametriSubject.next(res.parametri);
            this.loggedIn = true;
            //this.us.getMe().subscribe(
            //  (me) => {
            //    this.ss.setCurrentUtente(me);
            //   // notifico ai sottoscrittori interessati che un nuovo utente ha fatto login
            //    this.utenteSubject.next(me);
            //  },
            //  (err) => {}
            //);
          } else {
            notify('Errore aggiornamento password', 'warning', 3000);
          }
        }),
        catchError((err) => {
          if (err?.error?.title) {
            notify(err?.error?.title, 'error');
          } else {
            notify('Errore aggiornamento password', 'error');
          }
          console.error('auth error');
          return of(err);
        }),
      );
  }

  refreshToken(): Observable<any> {
    return this.http.get<any>(this.refreshTokenUrl).pipe(
      tap((res) => {
        this.ss.setCurrentToken(res.newToken);
        if (res.expirationLocal) {
          this.ss.setCurrentTokenExpiration(moment(res.expirationLocal));
        }
      }),
      catchError((err) => {
        notify('Errore refresh token', 'warning', 1000);
        console.error('auth error');
        return of(err);
      }),
    );
  }

  logOut() {
    this.cleanTempList();
    this.loggedIn = false;
    this.ss.removeCurrentUser();
    this.utenteSubject.next(undefined);
    this.permessiSubject.next(undefined);
    this.router.navigate(['/login-form']);
  }

  logOutFromMicrosoft() {
    this.cleanTempList();
    this.loggedIn = false;
    this.ss.removeCurrentUser();
    this.utenteSubject.next(undefined);
    this.permessiSubject.next(undefined);
    this.router.navigate(['/login-form']);

    const account = this.msalService.instance.getActiveAccount();
    this.msalService.instance.setActiveAccount(null);
    this.msalService.instance.clearCache({ account });
    sessionStorage.clear();
    this.msalService.logoutRedirect({
      account,
      postLogoutRedirectUri: environment.frontChannelUrl,
      logoutHint: account.idTokenClaims.login_hint,
    });
  }

  loginByEntraId(accessToken: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + accessToken,
    });

    return this.http
      .post<any>(this.securityByEntraIdUrl, null, { headers })
      .pipe(
        tap((res) => {
          this.ss.setCurrentToken(res.token);
          this.loggedIn = true;
          this.ss.setCurrentUtente(res.utente);
          //this.ss.setCurrentExpiration(token.expirationLocal);
          this.ss.setCurrentPermessi(res.permessi);
          if (res.expirationLocal) {
            this.ss.setCurrentTokenExpiration(moment(res.expirationLocal));
          }
          this.loggedIn = true;

          this.utenteSubject.next(res.utente);
          this.permessiSubject.next(res.permessi);
        }),
        catchError((err) => {
          notify(`Errore login by entraid`, 'warning', 1000);
          console.error('auth error');
          return of(err);
        }),
      );
  }

  cleanTempList(){
    this.articoliService.cleanTemp();
    this.categorieArticoliService.cleanTemp();
    this.causaliMovService.cleanTemp();
    this.dipendentiService.cleanTemp();
    this.distributoriService.cleanTemp();
    this.mansioniService.cleanTemp();
    this.movimentiArticoliService.cleanTemp();
    this.repartiService.cleanTemp();
    this.sitiService.cleanTemp();
    this.tipiArticoliService.cleanTemp();
  }

  get isLoggedIn() {
    return this.loggedIn;
  }

  private loadToken() {
    if (this.ss.currentToken) {
      console.log('found token in storage');
      this.ss.provideStorageTokenAsNextToken();
      this.loggedIn = true;
    }
  }

  get utenteCambiato(): Observable<Utente> {
    return this.utenteSubject.asObservable();
  }

  get utenteCorrente(): Utente {
    return this.utenteSubject.value;
  }
}

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
  private router = inject(Router);
  private authService = inject(AuthService);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const isLoggedIn = this.authService.isLoggedIn;
    const isLoginForm = route.routeConfig.path === 'login-form';

    if (isLoggedIn && isLoginForm) {
      this.router.navigate(['/']);
      return false;
    }

    if (!isLoggedIn && !isLoginForm) {
      this.router.navigate(['/login-form']);
    }

    return isLoggedIn || isLoginForm;
  }
}

@Injectable({ providedIn: 'root' })
export class OnlyAdminService implements CanActivate {
  private authService = inject(AuthService);
  private storageService = inject(StorageService);

  canActivate(): boolean {
    const isLoggedIn = this.authService.isLoggedIn;
    
    if (isLoggedIn && this.storageService.utenteCorrente.ruoloString == RUOLO_AMMINISTRATORE) {
      return true;
    }
    notify("Non hai accesso a questa sezione con le tue credenziali", "error");
    this.authService.logOut();
    return false;
  }
}


@Injectable({ providedIn: 'root' })
export class NotBaseService implements CanActivate {
  private authService = inject(AuthService);
  private storageService = inject(StorageService);

  canActivate(): boolean {
    const isLoggedIn = this.authService.isLoggedIn;
    
    if (isLoggedIn && this.storageService.utenteCorrente.ruoloString != RUOLO_OPERATORE_BASE) {
      return true;
    }
    notify("Non hai accesso a questa sezione con le tue credenziali", "error");
    this.authService.logOut();
    return false;
  }
}

@Injectable({ providedIn: 'root' })
export class OnlyBaseService implements CanActivate {
  private authService = inject(AuthService);
  private storageService = inject(StorageService);

  canActivate(): boolean {
    const isLoggedIn = this.authService.isLoggedIn;
    
    if (isLoggedIn && this.storageService.utenteCorrente.ruoloString == RUOLO_OPERATORE_BASE) {
      return true;
    }
    notify("Non hai accesso a questa sezione con le tue credenziali", "error");
    this.authService.logOut();
    return false;
  }
}